// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"ZD-z","smallCardRow":"_D-z","largeCardRow":"aE-z","productSearchRow":"bE-z","curatedRow":"cE-z"};